// import Swiper bundle with all modules installed
import Swiper from "swiper/bundle";
// import styles bundle
import "swiper/css/bundle";

(() => {
  const Moonbase = window.Moonbase || {};
  const swipers = document.querySelectorAll(".swiper");
  const defaultSettings = {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: false,
  };
  Moonbase.Swiper = Swiper;

  swipers.forEach((swiper) => {
    let settings = swiper.dataset.swiper
      ? JSON.parse(swiper.dataset.swiper)
      : defaultSettings;
    return new Swiper(swiper, settings);
  });

  Moonbase.initSwiper = (swiper) => {
    let settings = JSON.parse(swiper.dataset.swiper || "{}");
    new Swiper(swiper, {
      ...defaultSettings,
      ...settings
    });
  };

  const mobileSwiper = document.querySelectorAll(".swiper-mobile");
  const mobileSwiperSettings = {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: false,
  };

  function initMobileSwiper() {
    if (window.innerWidth < 1024) {
      mobileSwiper.forEach((mobileSwiper) => {
        let settings = mobileSwiper.dataset.swiper
          ? JSON.parse(mobileSwiper.dataset.swiper)
          : mobileSwiperSettings;

        return new Swiper(mobileSwiper, settings);
      });
    } else {
      mobileSwiper.forEach((mobileSwiper) => {
        if (mobileSwiper.swiper) {
          const slides = mobileSwiper.swiper.slides;
          mobileSwiper.swiper.destroy(true,true);

          // Remove inline styles added by swiper
          slides.forEach((slide) => {
            slide.removeAttribute("style");
          });
        }
      });
    }
  }

  Moonbase.initSwiper = (swiper) => {
    let settings = JSON.parse(swiper.dataset.swiper || "{}");
    return new Swiper(swiper, {
      ...defaultSettings,
      ...settings,
    });
  };

  window.addEventListener("resize", initMobileSwiper);
  window.addEventListener("DOMContentLoaded", initMobileSwiper);

})();
